import styled, { css } from 'styled-components';

import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakpoints } from '~/src/features/tariffLines/styled';

export const CardWrapper = styled.div<{ bgColor?: string, withCellSpacing: boolean }>`
    display: flex;
    justify-content: space-around;
    position: relative;
    cursor: pointer;
    flex-wrap: nowrap;
    flex-direction: column;
    padding: 8px 8px 16px 8px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background: ${({ bgColor }) => bgColor || COLORS.BgSurface};
    width: 380px;
    transition: box-shadow .3s;
    ${({ withCellSpacing }) => withCellSpacing && css`
        margin-right: 24px;
        margin-bottom: 24px;
       
        @media (max-width: 480px) {
            margin-right: 12px;
        }
    `};
    
    @media (max-width: ${breakpoints.tablet}) {
        max-width: 360px;
        margin-right: 16px;
    }
    
    @media (max-width: ${breakpoints.mobile}) {
        max-width: 328px;
    }
    
    &:hover {
        box-shadow: 0 12px 24px rgba(26, 26, 26, 0.06);
    }
`;

export const Bottom = styled.div`
    margin-top: 4px;
    display: flex;
    position: relative;
    min-height: 40px;
    align-content: center;
    align-items: center;
    justify-content: space-between;
`;

export const Text = styled.div`
    ${FONTS.H4};
    padding-left: 16px;
`;

export const Button = styled.div`
    position: relative;
    height: 40px;
    width: 40px;
    right: 16px;
    cursor: pointer;
    background-image:  url('${require('~/static/images/icons/arrow_right_white.svg')}');
`;

export const Header = styled.div<{ backgroundColor?: string }>`
    position: relative;
    height: 80px;
    border-radius: ${BorderRadius.InnerBlockRadius};
    background-color: ${p => p.backgroundColor ?? '#250900'};
`;

export const HeaderText = styled.div<{ color?: string }>`
    ${FONTS.S};
    color: ${p => p.color ?? '#fff'};
    margin: 16px 0 0 16px;
    max-width: 60%;
    
    @media (max-width: ${breakpoints.mobile}) {
        ${FONTS.XS};
    }
`;

export const HeaderImage = styled.div`
    position: absolute;
    right: 0;
    bottom: -2px;
    max-width: 40%;
    
    & img{
        width: 100%;
    }
`;
